import axios from "axios";
import { useEffect, useState } from "react";
import Box from "elements/Box";
import { Button, IconButton, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { ProjectConfig } from "Global";
import AlertDialog from "elements/AlertDialog";
import AddIcon from "@mui/icons-material/Add";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { useSnackbar } from "notistack";

import "assets/css/main.css";

import UndeliveredConceptEditor from "./UndeliveredConceptEditor";
import { ApiRequest } from "GlobalFunctions";

export default function UndeliveredConceptList(props: any) {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoading } = props;

  useEffect(() => {
    setLoading(false);
  }, []);

  const [list, setList] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [openEditor, setOpenEditor] = useState(false);
  const [activeItem, setActiveItem] = useState<any>(null);
  const [openAlert, setOpenAlert] = useState(false);

  useEffect(() => {
    setLoading(true);
    loadList();
  }, [page]);

  const loadList = () => {
    setLoading(true);


    ApiRequest({
      url: "/undelivered/list_concept",
      method: "GET",
      headers: {
        ltkn: localStorage.getItem("ltkn") || "",
      },
      query: {
        page: page,
      },
      setResponse: (data: any) => {
        setList(data.list);
        setTotalPages(data.total_pages);
        setLoading(false);
      },

    });
  }
  

  const handleDelete = (undelivered_concept_id: number) => {
    setActiveItem(undelivered_concept_id);
    setOpenAlert(true);
  };

  const deleteItem = () => {
    const body = JSON.stringify({
      undelivered_concept_id: activeItem,
    });

    axios
      .post(ProjectConfig.api_url + "/undelivered/deleteItem_concept", body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          enqueueSnackbar("Concepto no entregado eliminado con éxito", { variant: "success" });
          loadList();
        }
      })
      .catch((err) => {
        console.log(err.data);
      })
      .finally(() => {
        setOpenAlert(false);
      });
  };

  return (
    <div id="UndeliveredConceptList" className="ModuleContainer">
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Conceptos no entregados</h2>
            <span className="h2_subtitle">Lista de conceptos no entregados</span>
          </div>
          <div className="boxContainerActions">
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setActiveItem(null);
                setOpenEditor(true);
              }}
              startIcon={<AddIcon />}
            >
              Crear concepto no entregado
            </Button>
          </div>
        </div>

        <Box id="UndeliveredConceptListIn" className="box100">
          <TableContainer>
            <Table aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>ID</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>CONCEPTO</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item, i) => (
                  <TableRow key={i} hover role="checkbox">
                    <TableCell>{item.undelivered_concept_id}</TableCell>
                    <TableCell>{item.concept}</TableCell>
                    <TableCell align="right">
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        style={{ marginRight: "10px" }}
                        startIcon={<ModeEditIcon />}
                        onClick={() => {
                          setActiveItem(item.undelivered_concept_id);
                          setOpenEditor(true);
                        }}
                      >
                        Editar
                      </Button>
                      <IconButton aria-label="delete" color="primary" onClick={() => handleDelete(item.undelivered_concept_id)}>
                        <DeleteOutlineOutlinedIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(event, value) => setPage(value)}
            color="primary"
            style={{ marginTop: "20px", alignSelf: "center" }}
          />
        </Box>
      </div>

      <AlertDialog
        open={openAlert}
        setOpen={setOpenAlert}
        subtitle="¿Está seguro que desea eliminar este concepto no entregado?"
        send={deleteItem}
      />

      <UndeliveredConceptEditor
        setLoading={setLoading}
        openEditor={openEditor}
        setOpenEditor={setOpenEditor}
        undelivered_concept_id={activeItem}
        loadList={loadList}
      />
    </div>
  );
}
